
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button, Grid, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { startSavingUniMedida } from "../../../../services";

import Swal from "sweetalert2";





export const FormCreateUpdateMedida = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();


    const [formProducto, setFormProducto] = useState( initialState );
    const { nombre } = formProducto;
    const  handleChangeInput = ({ target }) => {
        setFormProducto({ ...formProducto, [target.name]: target.value});
    }

    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        const isUpdate = (id != 'new') ? id : null;
        if([nombre].includes('') ){
            return Swal.fire('Error', 'Formulario incorrecto por favor llene todos los campos', 'error');
        }

        const result = await Swal.fire({
            title: `${(id) ? 'Actualizar' : 'Crear'} Medida`,
            text: `¿Esta seguro de ${(isUpdate) ? 'Actualizar' : 'Crear'} Medida?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingUniMedida({...formProducto, id: isUpdate });
        if(resp){
            if(!isUpdate) { 
                setFormProducto(initialState); 
            }else {
                queryClient.invalidateQueries({queryKey: ['medidas-id', id]});
            }
            queryClient.invalidateQueries({queryKey: ['medidas-list']});
        }
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nombre'
                        type='text'
                        placeholder='Nombre'
                        fullWidth
                        name='nombre'
                        value={ nombre }
                        onChange={ handleChangeInput }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${(id != 'new') ? 'Actualizar' : 'Crear'} Medida`}
                    </Button>
                </Grid>
            </Grid>
        </form>
    )
}
